import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PaymentType } from '../../../types/Finance';

const initialState:PaymentType = {
  description: '',
  amount: 0
}

const paymentTypeSlice = createSlice({
  name: "paymentType",
  initialState,
  reducers: {
    setPaymentTypeData:(state, action:PayloadAction<PaymentType>)=>({...state, ...action.payload}), 
    resetPaymentTypeData :()=>({...initialState})
  }
});

export const {setPaymentTypeData,resetPaymentTypeData} = paymentTypeSlice.actions

export default paymentTypeSlice.reducer